import React from "react";

export const HydrogenForTransport = [
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col70">
      <h4 className="slideTitle">
        More than 50 Shell Hydrogen fuelling stations around the world
      </h4>
      <p>
        We invest heavily in fuel cell technologies for decarbonizing transports
        whose emissions are hard to abate.
      </p>
      <ul className="shell_bullets_list">
        <li>
          Hydrogen is an increasingly appealing option for the transport sector
          where other <strong>low-carbon alternatives</strong> are of limited
          use. Its <strong>high energy density</strong> makes it particularly
          suitable for trucks, trains and ships, which carry heavy goods over
          long distances.
        </li>
        <li>
          We are{" "}
          <strong>
            collaborating with transport manufacturers and governments
          </strong>{" "}
          to build and expand refuelling infrastructures to support emerging
          hydrogen powered fleets.
        </li>
        <li>
          Part of the German joint venture, H2 MOBILITY, to develop nationwide
          network of H2 refuelling stations
        </li>
        <li>
          Working with Toyota to expand the network of H2 refuelling stations in
          California
        </li>
        <li>
          HySTRA’s first voyage of world’s first hydrogen carrier demonstrating
          the transport of liquid hydrogen in a safe manner through demonstrated
          technical feasibility
        </li>
      </ul>
    </div>
    <div className="colRight col30">
      <img
        src="images/H2Transport-grid.JPG"
        width="100%"
        height="auto"
        alt=""
      />
    </div>
  </div>,
  <>
    <h4 className="slideTitle">Why hydrogen for heavy-duty transport?</h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/H2TransportHeavyDuty.JPG" width="100%" height="auto" />
    </div>
  </>,
  <>
    <h4 className="slideTitle">Shell hydrogen for transport E2E value chain</h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/H2TransportE2E.JPG" width="100%" height="auto" />
    </div>
  </>,
];
